export default "__VITE_ASSET__BzFafWiy__"